export enum FetchStatus {
    Idle = 'idle',
    Loading = 'loading',
    Success = 'success',
    Error = 'error',
}

export interface FetchResult<TResult> {
    status: FetchStatus;
    result?: TResult;
    error?: string;
}
